
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//缅甸
export const lang ={
  Please_set_materialtype_in_product_page:"ကျေးဇူးပြု၍ ထုတ်ကုန်တစ်ခုစီ၏ ပစ္စည်းအမျိုးအစား - အချောထည်ပစ္စည်းများ - တစ်ဝက်ချောထုတ်ကုန်များ - ဆက်စပ်ပစ္စည်းများကို ပြင်ဆင်သတ်မှတ်ရန် ထုတ်ကုန်စာမျက်နှာသို့ သွားပါ။",
deleteAccount:"ထွက်လိုက်ပါ။",
deleteAccountWillDeleteAllData:"သင့်အကောင့်မှ ထွက်ခွာပါက ဒေတာအားလုံးကို ဖျက်ပစ်မည်ဖြစ်ပြီး သင်ဝင်ရောက်၍မရတော့ပါ။",
backupDatabase:"အရန်ဒေတာဘေ့စ်",
restoreDatabase:"ဒေတာဘေ့စ်ကို ပြန်ယူပါ။",
materialtype:"ပစ္စည်းအမျိုးအစား",
Manufacturing:"ထုတ်လုပ်မှုဗားရှင်း",
Professional:"ပရော်ဖက်ရှင်နယ်ဗားရှင်း",
Standard:"Standard Edition",
product:"ကုန်ချော",
halfProduct:"တစ်ပိုင်းကုန်ချောထုတ်ကုန်",
components:"ဆက်စပ်ပစ္စည်းများ",
Parent:"မိဘအစိတ်အပိုင်း",
Children:"ဆက်စပ်ပစ္စည်းများ",
Level:"အထက်အောက်",
Timing:"အချိန်ကိုက်",
PieceCount:"ဖဲချပ်",
Wages:"လုပ်အားခ",
InternalProcess:"အတွင်းရေးလုပ်ငန်းစဉ်",
ExternalProcess:"ပြင်ပလုပ်ငန်းစဉ်",
ProceName:"လုပ်ငန်းစဉ်အမည်",
ProceIndex:"ကွပ်မျက်မိန့်",
ChargeMan:"ကျောင်းအုပ်",
BillMethod:"ငွေတောင်းခံနည်း",
ConsumTime:"အလုပ်ချိန်",
Accessories:"ဆက်စပ်ပစ္စည်းများ",
Assembly:"စုစည်းပါ။",
materials:"သင်ထောက်ကူပစ္စည်းများ",
task:"တာဝန်",
process:"လုပ်ငန်းစဉ်",
BOM:"BOM",
Production:"ထုတ်လုပ်မှု",
RestorePurchaseOneUse:"ဝယ်ယူမှုကို ပြန်လည်ရယူပါ (အသုံးပြုသူတစ်ဦး (ယခင်ဝယ်ယူမှုများတွင် ကန့်သတ်ထားသည်))",
buy_fail_try_again:"ဝယ်ယူရန် ထပ်မံနှိပ်ပါ။",
Export:"တင်ပို့ခြင်း။",
Date:"ရက်စွဲ",
BankDetail:"ဘဏ်အသေးစိတ်",
Seller:"ရောင်းသူ",
Buver:"ဝယ်သူ",
Currency:"ငွေကြေး",
CompanyName:"ကုမ္ပဏီအမည်",
ProformaInvoice:"ကြိုတင်ကုန်ပို့လွှာ",
Discount:"လျှော့စျေး",
PayStatus:"ငွေပေးချေမှုအခြေအနေ",
ShippingStatus:"ပို့ဆောင်မှုအခြေအနေ",
FreightType:"သယ်ယူပို့ဆောင်ရေးအမျိုးအစား",
Shipping:"ကုန်စည်ပို့ဆောင်ရေး",
Payment:"ငွေပေးချေမှု",
Moneyname:"ငွေကြေးအမည်",
Tax:"အခွန်",
Freight:"ကုန်စည်ပို့ဆောင်ခများ",
Insurance:"အာမခံ",
Bankfee:"ဘဏ်အခကြေးငွေ",
Qc:"အရည်အသွေးလက်မှတ်",
Exchangerate:"ငွေလဲလှယ်နှုန်း",
Shippingnumber:"ပို့ဆောင်မှုနံပါတ်",
ShipDate:"သင်္ဘောရက်စွဲ",
Arrivedate:"ဆိုက်ရောက်မည့်ရက်",
Grossweight:"စုစုပေါင်းအလေးချိန်",
CubicWeight:"ကုဗအလေးချိန်",
Totalpackages:"ပက်ကေ့ဂျ်စုစုပေါင်းအရေအတွက်",
Moneytype:"ငွေကြေးအမျိုးအစား",
Quotedate:"ကိုးကားရက်စွဲ",
Validitydate:"တရားဝင်ရက်စွဲ",
Paymentterm:"လစာသက်တမ်းကုန်ဆုံး",
Priceterm:"စျေးနှုန်းသက်တမ်း",
DeliveryTerm:"ပို့ဆောင်ချိန်",
BankName:"ဘဏ်အမည်",
BankAddress:"ဘဏ်လိပ်စာ",
SwiftCode:"ဘဏ်ကုဒ်",
Review:"သုံးသပ်ချက်",
Signfor:"ပြေစာအတွက် လက်မှတ်ထိုးပါ။",
Finance:"ဘဏ္ဍာရေး",
Receiver:"လက်ခံသူ",
Business:"စီးပွားရေး",
ContactPerson:"ဆက်သွယ်ရမည့်သူ",
Profit:"အမြတ်အစွန်း",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"ဝန်ထမ်းများသည် Google Chrome ကို အသုံးပြုရပါမည်။ ကျေးဇူးပြု၍ ပင်မဝန်ဆောင်မှုကွန်ပြူတာ APP ၏ အကူအညီစာမျက်နှာရှိ IP လိပ်စာကို စစ်ဆေးပါ၊ ထို့နောက် အကောင့်ဖွင့်ရန် အခြားကွန်ပျူတာဘရောက်ဆာများ၏ URL ကော်လံတွင် လိပ်စာကို ထည့်သွင်းပါ။",
newPassword:"စကားဝှက်အသစ်",
ForgetPassword:"စကားဝှက်ကိုမေ့",
ContactUs:"ကျွန်ုပ်တို့ထံ ဆက်သွယ်ပါ/ အကြံပြုချက်ပေးပါ။",
Actualpay_should_big_then_shouldpay:"ပြေစာအစစ်အမှန်သည် လက်ခံရနိုင်သည့်ပမာဏထက် မကြီးနိုင်ပါ။",
ShopAddress:"အော်ဒါတင်ရန် ကျွန်ုပ်၏ စတိုးဆိုင်လိပ်စာကို QR ကုဒ်ကို စကင်န်ဖတ်ပါ။",
Submit:"တင်ပြပါ။",
All:"အားလုံး",
OrdernumExists:"အော်ဒါနံပါတ် ရှိပြီးသားပါ။",
PermissionDenied:"ခွင့်တောင်းမှုငြင်းဆိုခြင်း",
StockTransfer:"စတော့ရှယ်ယာလွှဲပြောင်း",
FromWarehouse:"ဂိုဒေါင်ထဲက လွှဲပေးတယ်။",
ToWarehouse:"ဂိုဒေါင်သို့လွှဲပြောင်း",
PleaseUseInWebBrowser:"Google Chrome တွင် ထုတ်ယူခြင်း Excel လုပ်ဆောင်ချက်ကို အသုံးပြုပါ။",
PleasePrintInWebBrowser:"Google Chrome တွင် ပရင့်လုပ်ဆောင်ချက်ကို အသုံးပြုပါ။",
HistoryPrice:"သမိုင်းစျေးနှုန်း",
SerialNumber:"နံပါတ်စဥ်",
Please_Use_In_APP:"ကျေးဇူးပြု၍ ကွန်ပြူတာဆော့ဝဲလ်တွင် အသုံးပြုပါ။",
Please_Purchase_In_APP:"ကျေးဇူးပြု၍ ဘရောက်ဆာအတွင်းမဟုတ်ဘဲ အက်ပ်အတွင်းတွင် ဝယ်ယူပါ။",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"သင်သည် Postgresql ဒေတာဘေ့စ်သို့ ချိတ်ဆက်နိုင်သည်။ သင့်ဒေတာများကို Postgresql ဒေတာဘေ့စ်တွင် သိမ်းဆည်းထားမည်ဖြစ်သည်။ ပုံမှန်အားဖြင့်၊ သင်သည် Postgresql ဒေတာဘေ့စ်သို့ ချိတ်ဆက်ရန် မလိုအပ်ပါ။ ပုံသေမှာ ဒေသတွင်း Sqlite ဒေတာဘေ့စ်ဖြစ်သည်။",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Postgresql ဒေတာဘေ့စ်သို့ ချိတ်ဆက်ပါ၊ သင်၏ဒေတာကို Postgresql ဒေတာဘေ့စ်တွင် သိမ်းဆည်းမည်ဖြစ်ပြီး ဒေတာကို ထပ်မံဖတ်ရှုပါမည်",
Use_sqlite_data_will_store_in_local:"sqlite ကို အသုံးပြု၍ data များကို local machine တွင် သိမ်းဆည်းထားမည်ဖြစ်သည်။",
UsePostgresqlDatabase:"PGSQL ဒေတာဘေ့စ်ကိုအသုံးပြုခြင်း။",
UseSqliteDatabase:"Sqlite ဒေတာဘေ့စ်ကိုအသုံးပြုခြင်း။",
DatabaseName:"ဒေတာဘေ့စ်အမည်",
Test_connect:"စမ်းသပ်ချိတ်ဆက်မှု",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"ထုတ်ကုန်တွင် အရောင် သို့မဟုတ် အရွယ်အစားရှိပါက၊ ကနဦးစာရင်းအတွက် ကျေးဇူးပြု၍ 0 ကိုဖြည့်ပါ။ ထုတ်ကုန်ကိုထည့်ပြီးနောက်၊ ဝယ်ယူမှုတွင် စာရင်းထည့်ပါ။",
my:"မိုင်း",
my_shop_qrcode_scan:"ကျွန်ုပ်၏စတိုး၏ QR ကုဒ်သည် သုံးစွဲသူများအား အော်ဒါတင်ရန်အတွက် ကုဒ်ကိုစကင်န်ဖတ်နိုင်စေပါသည်။ သုံးစွဲသူ၏မိုဘိုင်းဖုန်းသည် သင့်ကွန်ပျူတာနှင့်တူသော router နှင့် ချိတ်ဆက်ရပါမည်။",
ip:"အိုင်ပီ",
port:"ဆိပ်ကမ်း",
orderstatus:"အမိန့်အဆင့်အတန်း",
image:"ပုံ",
Template:"ပုံစံခွက်",
Please_select_a_excel_file:"ကျေးဇူးပြု၍ ဖိုင်တစ်ခုကို ရွေးပါ။",
Please_select_only_one_excel_file:"ဖိုင်တစ်ခုသာ ရွေးနိုင်သည်။",
Connect_Internet_Login_again:"အင်တာနက်ချိတ်ဆက်ပြီး မဝယ်ယူမီ ထပ်မံဝင်ရောက်ပါ။",

    productHasValidDate:'ကုန်ပစ္စည်းများတရားဝင်များမှာ',
productHasColor:'ကုန်ပစ္စည်းအရောင်အရွယ်အစား',
GeneralGoods:'အထွေထွေကုန်သွယ်',
Selected:'Selected',
RestorePurchase:'ဝယ်ယူ Restore',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'အမြဲတမ်းဝယ်ယူရန်ပြေစာပို့လုပ်ငန်း 1 ခုသည်အသုံးပြုသူများ',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'အသုံးပြုသူများနှင့်ထုတ်ကုန်လုပ်ငန်းအမြဲတမ်းပြေစာပို့တစ်ခုန့်အသတ်အရေအတွက်က Buy',
Purchasing:'စောင့်ဆိုင်းပေးပါ ... ဝယ်ယူ ...',
Validdate:'တရားဝင်မှု',
Makedate:'ထုတ်လုပ်မှုနေ့စွဲ',
Batch:'အသုတ်',
CheckVersion:'ဗားရှင်း Check',
Please_set_this_ip_address_on_App:'အဆိုပါ APP ကိုအပေါ် IP လိပ်စာကိုပါသို့မဟုတ်ကွန်ပျူတာတစ်လုံးရဲ့ IP address ကိုသတ်မှတ်ပေးပါ',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'ဆက်သွယ်မှုဖွင့်ဖို့ကွန်ပျူတာသို့မဟုတ်မိုဘိုင်းဖုန်း (က Wi-Fi နှင့်အတူကွန်နက်ရှင်) ၏အမြင်တွင်',


    CheckVersion: 'ဗားရှင်းစစ်ဆေး',
You_need_to_purchase: 'ကိုသင်ဝယ်ယူကြပြီမဟုတ်, Micro-ရုပ်သံလိုင်းအဆက်အသွယ် Elink9988-mail ကို add ကျေးဇူးပြုပြီး: bvbuy@qq.com',
Thank_for_your_purchase: 'ကိုသင်မဝယ်ရန်ရှိသည်' ,
New_version_available: '၏ဗားရှင်းအသစ်လည်းမရှိ' ,
Is_the_latest_version: 'နောက်ဆုံးထွက်ဗားရှင်းဖြစ်ပါတယ်',
    please:'ကျေးဇူးပြု',
    input:'input ကို',
    wrong:'မှားသော',
    Verifycode:'ကုဒ်မှန်ကြောင်းအတည်ပြု',
    Upload:'လွှတ်တင်ခြင်း',
    Download:'ဒေါင်းလုပ်',
    You_need_to_purchase_to_continue_use:'သငျသညျအသုံးပြုမှုကိုဆက်လက်ဝယ်ယူရန်လိုအပ်',
    CheckBuy:'အရစ်ကျ Check',
    Exists:'တည်ရှိ',
    NetworkUnavailable:'ကွန်ယက်ကိုမရရှိနိုင်ပါ',
    Today:'ယနေ့တွင်',
    Yesterday:'မနေ့က',
    ThisMonth:'ဤလတွင်',
    LastMonth:'နောက်ဆုံးလ',
    nickname:'အမည်ပြောင်',
    storeName:'စတိုးဆိုင်အမည်',
    BuyStandAlone:'stand-alone ဗားရှင်းကိုဝယ်',
    PermissionDenied:'ခွင့်တောင်းမှုငြင်းဆိုခြင်း',
    Boss:'အကြီးအကဲ',

    login:'လော့ဂ်အင်',
operate:'ခှဲစိတျကုသ',
register:'စာရင်း',
username:'user name',
password:'Password ကို',
User:'အသုံးပြုသူကို',
ok:'အဆင်ပြေလား',
back:'ပြန်.',
success:'အောင်မြင်ခြင်း',
fail:'ဆုံးရှုံး',
cancel:'cancel',
add:'ပေါင်း',
edit:'ပြင်ဆင်ရန်',
delete:'ဖျက်ပစ်ပါ',
refresh:'အားဖြည့်',
close:'ပိတ်',
cancel:'Cancel',
return:'ပြန်လာ',
ElinkInvoice:'Elink ငွေတောင်းခံလွှာ',
Purchase:'အရစ်ကျ',
BaseData:'base ဒေတာများ',
Sell:'ရောင်းချ',
PurchaseReturns:'ပြန်ဝယ်ယူရန်',
SellReturns:'ပြန်ရောင်း',
Inventory:'စာရင်း',
Statistics:'စာရင်းအင်း',
Receivable:'receiver',
Payable:'ပေးအပ်သော',
Orders:'အမိန့်',
StockTransfer:'စတော့အိတ်လွှဲပြောင်း',
StockRecall:'စတော့အိတ်သတိရပါ',
Customer:'ဖောက်သည်',
Supplier:'ကုန်သွင်းသူ',
Warehouse:'ကုနျလှောငျရုံ',
Color:'အရောင်',
Size:'အရွယ်',
Category:'အမျိုးအစား',
Category2:'Category2',
Product:'ကုန်ပစ္စည်း',
Account:'အကောင့်',
AccountType:'အကောင့်အမျိုးအစား',
Staff:'ဝန်ထမ်း',
typeone:'အမျိုးအစား',
typetwo:'sub Category:',
ProductName:'ထုတ်ကုန်အမည်',
Specification:'specification',
Barcode:'ဘားကုဒ်',
Buyprice:'စျေးနှုန်းဝယ်ပါ',
Sellprice:'ရောင်းစျေးနှုန်း',
Wholesaleprice:'လက်ကားဈေးနှုန်း',
Currentstock:'ရေစီးကြောင်း Tock',
Unit:'ယူနစ်',
Initstock:'init စတော့ရှယ်ယာ',
Parameter:'parameter',
Remark:'ပွောဆို',
Supplier:'ကုန်သွင်းသူ',
Customer:'ဖောက်သည်',
Staff:'ဝန်ထမ်း',
Receivable:'receiver',
payable:'ပေးအပ်သော',
Receipts:'လက်ခံဖြတ်ပိုင်းများ',
Paid:'paid',
Preferential:'ဦးစားပေး',
DateDay:'နေ့စှဲ',
OrderNum:'အမှာစာနံပါတ်',
Name:'အမည်',
UserName:'အသုံးပြုသူအမည်',
IdNum:'ID ကိုနံပါတ်',
BirthDay:'မှေးနေ့',
SEX:'လိင်',
Female:'အမြိုးသမီး',
Male:'အထီး',
Select:'ကို Select လုပ်ပါ',
Address:'လိပ်စာ',
Phone:'ဖုန်းနံပါတ်',
Email:'အီးမေးလ်ပို့ရန်',
CardNum:'ကတ်နံပါတ်',
Price:'စျေးနှုန်း',
QTY:'အရည်အတွက်',
SupplierCategory:'ပေးသွင်း Category:',
CustomerCategory:'ဖောက်သည် Category:',
Power:'စွမ်းအား',
Role:'အခန်းက္ပ',
save:'ကြော်ငြာကို Save လုပ်ရန်',
image:'ပုံရိပ်',
search:'ရှာဖှေ',
Year:'ခုနှစ်',
Month:'လ',
Day:'နေ့',
Total:'စုစုပေါငျး',
WorkReport:'အလုပ်အစီရင်ခံစာ',
Leave:'ထွက်သွား',
CheckIn:'ရောက်ရှိကြောင်းစာရင်းသွင်းခြင်း',
Announcement:'ကြေညာချက်',
Approval:'ခွင့်ပြုချက်',
Tracking:'ခြေရာကောက်',
Bill:'ဘီလ်',
OrdersDetail:'အမိန့်အသေးစိတ်',
Expense:'သုံးငှေ',
Income:'ဝငျငှေ',
Userfor:'အသုံးပြုသူ၏',
Amount:'ငွေပမာဏ',
Title:'ခေါင်းစဥ်',
News:'သတင်း',
SelectFile:'ဖိုင်ကို Select လုပ်ပါ',
Content:'အကြောင်းအရာ',
Cost:'ပေးရ',
ApprovalUser:'ခွင့်ပြုချက်အသုံးပြုသူ',
ApprovalStatus:'ခွင့်ပြုချက်အခြေအနေ',
ApprovalRemark:'ခွင့်ပြုချက်မှတ်ချက်',
ApprovalDate:'ခွင့်ပြုချက်နေ့စွဲ',
SubmitDate:'နေ့စွဲ Submit',
Status:'status',
FromDateTime:'နေ့စွဲအချိန်ကနေ',
ToDateTime:'နေ့စွဲအချိန်မှ',
Subject:'ဘာသာရပ်',
Latitude:'လတီ္တတွဒ်',
Longitude:'လောင်ဂျီတွဒ်',
Print:'ပုံနှိပ်',
DataTrans:'ဒေတာကိုဖြတ်ကျော်',
OA:'oa',
Setting:'အစုံ',
Help:'ကူညီပါ',
ScanOpenInPhone:'ဖုန်းအတွက် Scan ကိုဖွင့်ပါ',
Building:'အဆောက်အဦး',
Room:'အခန်း',
HotelCheckIn:'ရောက်ရှိကြောင်းစာရင်းသွင်းခြင်း',
CheckOut:'ထွက်ခွာသည်',
Hotel:'ဟော်တယ်',
Checkintime:'အချိန်အတွက် Check',
Checkouttime:'အချိန်ထုတ်စစ်ဆေး',
Deposit:'အပျငှေ',
Cost:'ပေးရ',
RoomNum:'ROOM တွင် Num',
Rent:'ငှား',
costday:'costday',
rent:'ငှားရန်',
waternum:'ရေဒီဂရီ',
electricnum:'လျှပ်စစ်ဒီဂရီ',
gasnum:'ဓာတ်ငွေ့ဒီဂရီ',
watercost:'ရေကုန်ကျစရိတ်',
electriccost:'လျှပ်စစ်ကုန်ကျစရိတ်',
gascost:'ဓာတ်ငွေ့ကုန်ကျစရိတ်',
cleaningcost:'သန့်ရှင်းရေးကုန်ကျစရိတ်',
networkcost:'ကွန်ယက်ကိုကုန်ကျစရိတ်',
tvcost:'ရုပ်သံကုန်ကျစရိတ်',
managecost:'ကုန်ကျစရိတ်စီမံခန့်ခွဲ',
othercost:'သည်အခြားကုန်ကျစရိတ်',
totalcost:'စုစုပေါင်းကုန်ကျစရိတ်',
remark:'ပွောဆို',
addtime:'အချိန် add',
OpenInBrowser:'Browser ကိုခုနှစ်မှာပွင့်လင်း',
InventoryProfit:'စာရင်းအမြတ်',
InventoryLoss:'စာရင်းအရှုံး',
Buy:'ယ်ယူရန်',



Refresh:'ပြန်လည်စတင်',
Add:'ထည့်ရန်',
Search:'ရှာဖွေ',
Records:'မှတ်တမ်း',
}



// WEBPACK FOOTER //
// ./src/lang/mm.js